import React from 'react';
import { Animate} from "react-simple-animate";


import NextStepButton from "../../../Components/NextStepButton";


export default function WelcomeRight() {

    const rightBoxTitle = "Subscriptions/Memberships"

    const WelcomeRightCentralisation = " col-start-1 col-end-13"

    return (
        // <div className={`WelcomeRight col-start-1 col-end-13 row-start-5 lg:row-start-4 row-end-13 lg:row-end-12 hidden lg:grid grid-cols-12 grid-rows-12 text-center `}>
        <div className={`WelcomeRight col-start-1 col-end-13 row-start-5 lg:row-start-1 row-end-13  hidden lg:grid grid-cols-12 grid-rows-12 text-center `}>
            <Animate play
                     start={{opacity: 0}}
                     end={{
                         opacity: 1,
                         gridRowStart: 1,
                         gridRowEnd: 13,
                         textAlign: "center",
                         display: "grid",
                         gridColumnStart: 1,
                         gridColumnEnd: 13,
                         gridTemplateRows: "repeat(12, minmax(0, 1fr))",
                         gridTemplateColumns: "repeat(12, minmax(0, 1fr))",
                        }}
                     duration={0.7} >

                <div className={`WelcomeRight__title  ${WelcomeRightCentralisation} lg:row-start-3 lg:row-end-4  text-3xl font-semibold`}>{rightBoxTitle}</div>


            <div className={`WelcomeRight__corporate-title row-start-3 row-end-4 lg:row-start-5 lg:row-end-6 ${WelcomeRightCentralisation} font-semibold text-lg`}>
                Corporate Account
            </div>
            <div className={`WelcomeRight__corporate-text text-center row-start-4 row-end-5 lg:row-start-6 lg:row-end-7 ${WelcomeRightCentralisation}`}>
                Direct Debit paid yearly, with the price based on the number of accounts required.
            </div>
            <div className={`WelcomeRight__individual-title row-start-7 row-end-8 lg:row-start-7 lg:row-end-8 ${WelcomeRightCentralisation} font-semibold text-lg`}>
                Individual Account
            </div>
            <div className={`WelcomeRight__individual-text row-start-8 row-end-9 lg:row-start-8 lg:row-end-9 ${WelcomeRightCentralisation}`}>
                As an individual user pay for 1 month, 3-months, or for 1 year upfront.
            </div>

            <NextStepButton
                positionClassNames={" row-start-11 lg:row-start-10 lg:row-end-11  col-start-5  col-end-9 "}
                styleClassNames={" hidden lg:flex lg:flex-row justify-center items-center bg-gold-accent hover:bg-gold-accent-hover rounded-lg  h-12  py-1 text-xl "}
                pClassNames={" text-xl p-3  align-center justify-center flex "}
                iClassNames={" ri-arrow-right-line "}
                pContent={" Next "}
            />

            </Animate>
        </div>


    );
}
